import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { IconModule, SharedPipesModule } from '@grid-ui/common';
import { FeatureFlagService } from '@grid-ui/feature-flag';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { GlobalModuleAnnouncementFacade } from './data-access/+state/global-module-announcement.facade';
import { DataAccessGlobalModuleAnnouncementModule } from './data-access/data-access-global-module-announcement.module';
import { AnnouncementsDialogComponent } from './feature/components/announcements-dialog/announcements-dialog.component';

export function loadAnnouncements(facade: GlobalModuleAnnouncementFacade, featureFlagService: FeatureFlagService): () => Promise<void> {
  return async () => {
    await featureFlagService.initialise();
    facade.loadAnnouncements();
  };
}

@NgModule({
  declarations: [AnnouncementsDialogComponent],
  imports: [
    CommonModule,
    DataAccessGlobalModuleAnnouncementModule.forRoot(),
    NgbModalModule,
    NgbTooltipModule,
    SharedPipesModule,
    IconModule,
    FormsModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: loadAnnouncements,
      deps: [GlobalModuleAnnouncementFacade, FeatureFlagService],
      multi: true,
    },
  ],
  exports: [AnnouncementsDialogComponent],
})
export class GlobalAnnouncementsModule {}
